'use client';
import { getComputedStyle } from '../../utils/dom.js';

function isRTL(element) {
    return getComputedStyle(element).direction === 'rtl';
}

export { isRTL };
//# sourceMappingURL=isRTL.js.map
